import ProductItem from "./ProductItem";
import styles from "../pages/Products.module.css";

const ProductList = ({
  units,
  selectedAction,
  handleSelectedAction,
  selectedReason,
  handleSelectedReason,
  getActionName,
  selectedExplication,
  handleSelectedExplication,
}) => {
  return (
    <div className={styles.list} role="list">
      {units.map(({ skuId, line }) => (
        <ProductItem
          key={skuId}
          skuId={skuId}
          line={line}
          selectedAction={selectedAction}
          handleSelectedAction={handleSelectedAction}
          selectedReason={selectedReason}
          handleSelectedReason={handleSelectedReason}
          getActionName={getActionName}
          selectedExplication={selectedExplication}
          handleSelectedExplication={handleSelectedExplication}
        />
      ))}
    </div>
  );
};

export default ProductList;
